export default __webpack_public_path__ + "dc6fe7b3b10b286200cee593c4dd990e.woff2";